var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { isArray } from 'lodash';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Group } from '@/models/Group';
import { Lvs } from '@/models/Lvs';
import { LvsPeriod as Period } from '@/models/LvsPeriod';
import { Student } from '@/models/Student';
import { Subject } from '@/models/Subject';
import AInlineEditable from '@/components/InlineEditable/InlineEditable';
import AlertCard from '@/components/alert-card/AlertCard';
import LoaderCard from '@/components/loader-card/LoaderCard.vue';
import StatusPill from '@/components/StatusPill.vue';
import { userReportGoals } from '@/models/User';
let Report = class Report extends Vue {
    constructor() {
        super(...arguments);
        this.currentPeriodId = '';
        this.isLoading = true;
        this.areas = [];
        this.selectedArea = null;
        this.lvsPeriods = [];
        this.isLoadingPeriods = true;
        this.selectedPrevPeriod = null;
        this.selectedCurrPeriod = null;
        this.userGoals = userReportGoals;
    }
    async mounted() {
        this.isLoading = false;
        this.fetchLvsPeriods();
        this.fetchAreas();
    }
    async fetchLvsPeriods() {
        this.isLoadingPeriods = true;
        new Period()
            .filter({ is_active: true })
            .all()
            .then((periods) => {
            this.lvsPeriods = periods;
            this.isLoadingPeriods = false;
            return true;
        }).catch(() => {
            this.isLoadingPeriods = false;
        });
    }
    async fetchAreas() {
        this.isLoading = true;
        await new Subject()
            .include('lvs_subject_setting')
            .all()
            .then((areas) => {
            this.areas = this.patchAreas(areas);
            this.isLoading = false;
        }).catch(() => { this.isLoading = false; });
    }
    patchAreas(areas) {
        return areas.filter((area) => (area && area.lvs_subject_setting && area.lvs_subject_setting.is_active));
    }
    async updatePeriod(event, user, key) {
        const response = await new Student({ id: user.user_id })
            .setLvsResultsEndpoint()
            .create({
            area_id: this.selectedArea.id,
            lvs_period_id: user.current_period.id,
            [key]: event.value,
        })
            .catch(() => event.setFailedState());
        if (response) {
            event.setSuccessState();
        }
    }
    async fetchSelectedArea() {
        if (!(this.selectedArea && this.selectedArea.id)
            || !(this.selectedCurrPeriod && this.selectedCurrPeriod.id)
            || !(this.selectedPrevPeriod && this.selectedPrevPeriod.id)) {
            return;
        }
        this.isLoading = true;
        new Lvs()
            .filter({
            groups: [this.group.id],
            areas: [this.selectedArea.id],
            lvs_periods: [this.selectedCurrPeriod.id, this.selectedPrevPeriod.id],
            current_period: this.selectedCurrPeriod.id,
            previous_period: this.selectedPrevPeriod.id,
        })
            .all()
            .then((response) => {
            const found = response.find((item) => this.selectedArea && item.name === this.selectedArea.name);
            this.selectedArea = found ? found : response[0];
            this.isLoading = false;
        });
    }
    async onUpdateDescription(event, user) {
        const response = await new Student({ id: user.user_id })
            .setLvsAreasEndpoint()
            .create({
            subject_id: this.selectedArea.id,
            notes: event.value,
        })
            .catch(() => event.setFailedState());
        if (response) {
            event.setSuccessState();
        }
        user.notes = response.notes;
    }
    async onUpdateGoal(value, user) {
        const response = await new Student({ id: user.user_id })
            .setLvsAreasEndpoint()
            .create({
            subject_id: this.selectedArea.id,
            goal: value,
        });
        if (!response) {
            this.isLoading = true;
            this.fetchAreas();
        }
    }
    get selectedAreaUserData() {
        if (!(this.selectedArea && this.selectedArea.id)
            || !(this.selectedCurrPeriod && this.selectedCurrPeriod.id)
            || !(this.selectedPrevPeriod && this.selectedPrevPeriod.id)) {
            return [];
        }
        const userData = [];
        //  prefill with users data (inlude the id)
        Object.keys(this.selectedArea && this.selectedArea.users || []).forEach((key) => {
            if (isArray(this.selectedArea.users[key])) {
                return;
            }
            const userClone = this.selectedArea.users[key];
            userClone.user_id = key;
            userData.push(userClone);
        });
        userData.forEach((user) => {
            const currentPeriod = this.selectedArea.periods.find((period) => this.selectedCurrPeriod.id === period.id);
            const previousPeriod = this.selectedArea.periods.find((period) => this.selectedPrevPeriod.id === period.id);
            user.current_period = currentPeriod.users[user.user_id] || null;
            user.current_period.id = currentPeriod.id;
            user.current_period.name = currentPeriod.name;
            user.previous_period = previousPeriod.users[user.user_id] || null;
            user.previous_period.id = previousPeriod.id;
            user.previous_period.name = previousPeriod.name;
        });
        return userData.sort((a, b) => a.name.localeCompare(b.name));
    }
    get showAlertCard() {
        if (!(this.selectedArea && this.selectedArea.id)
            || !(this.selectedCurrPeriod && this.selectedCurrPeriod.id)
            || !(this.selectedPrevPeriod && this.selectedPrevPeriod.id)) {
            return true;
        }
        return false;
    }
    setFailedState(event) {
        setTimeout(() => {
            event.setFailedState();
        }, 300);
    }
};
__decorate([
    Prop({ default: () => new Group() }),
    __metadata("design:type", typeof (_a = typeof Group !== "undefined" && Group) === "function" ? _a : Object)
], Report.prototype, "group", void 0);
Report = __decorate([
    Component({
        components: {
            AInlineEditable,
            StatusPill,
            LoaderCard,
            AlertCard,
        },
    })
], Report);
export default Report;
